import gql from 'graphql-tag';

import type { EntityComplianceData } from 'src/data/compliance';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_VARIATION_COMPLIANCE } from './schema';

const QUERY = gql`
  query ComplianceForVariations($variationIds: [ID!]!) {
    complianceForVariations(variationIds: $variationIds) {
      ...VariationCompliance
    }
  }
  ${FRAGMENT_VARIATION_COMPLIANCE}
`;

interface Params {
  variationIds: ID[];
}

export const queryComplianceForVariations = async ({ variationIds }: Params) => {
  const variables = { variationIds };

  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<EntityComplianceData[]>(result.data);
};
